module.exports = __webpack_public_path__ + "static/fonts/BMHANNAPro.ttf?ad793ad8";